import React from "react"
import classes from "./Tabs.module.css"
import Tab from "../../components/Tabs/Tab/Tab"

const Tabs = props => {
    const TABS = ["Profile", "Gear Seed", "Seed Listing"]
    return (
        <ul className={classes.Nav}>
            {TABS.map((v, idx) => {
                return <Tab title={v} key={idx} clicked={props.clicked} active={props.active === idx} num={idx} />
            })}
        </ul>
    )
}

export default Tabs
